import { DecisionResponse, AiCaseSummaryResponse, PutDecisionRequest } from '../types/types';
import { HttpResponse, makeRequest } from './index';

const endpoint = 'Decision';

export const getDecision = async (id: string): Promise<HttpResponse<DecisionResponse>> => {
	const result = await makeRequest<string, DecisionResponse>(`${endpoint}?decisionId=${id}`, null, 'get');
	return result;
};

export const putDecision = async (request: PutDecisionRequest): Promise<HttpResponse<null>> => {
	const result = await makeRequest<PutDecisionRequest, null>(`${endpoint}`, request, 'put');
	return result;
};

export const getAISuggestions = async (caseId: string): Promise<HttpResponse<AiCaseSummaryResponse[]>> => {
	const result = await makeRequest<string, AiCaseSummaryResponse[]>(`${endpoint}/suggestions/${caseId}`, null, 'get');
	return result;
};
